import axios from 'axios';
export const apiUploadDocument = async (data, authHeader) => {
    return axios.post('/mlp-ui-service/api/documents/upload', data, {
        headers: {
            Authorization: authHeader,
            'Content-Type': 'multipart/form-data',
        },
    });
};
